import { checkIsAvailableForRentInFuture, generateCategoryPositionTables, generateTablesOfUniqueCategories } from 'containers/MapDetails/utils'
import AvailabilityNotificationPopup from 'containers/MapDetails/popups/AvailabilityNotificationPopup'
import { addItemToBasket, BASKET_TYPES, extendFormToMap } from 'containers/OrderDetails/basketSlice'
import { selectPlaceData, selectPlaceTypes } from 'containers/MapDetails/placeSlice'
import useFreshPlaceData from 'containers/MapDetails/hooks/useFreshPlaceData'
import WarehouseAttrPopup from 'containers/Maps/Popups/WarehouseAttrPopup'
import MagElement, { countBadge } from 'containers/MapDetails/MagElement'
import DetailsPopup from 'containers/MapDetails/popups/DetailsPopup'
import AutomationPopup from 'containers/Maps/Popups/AutomationPopup'
import AdditionalText from 'containers/Maps/Result/AdditionalText'
import { selectFilters } from 'containers/Maps/menu/filtersSlice'
import PlaceTemplatePhoto from 'components/PlaceTemplatePhoto'
import GalleryPopup from 'components/popups/GalleryPopup'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import { displayPrice } from 'utils/string'
// import MmRating from 'components/MmRating'
import { selectConfig } from 'appSlice'
import Carousel from './Carousel'
import { v7 } from 'uuid'
import './style.scss'

interface PlaceElementProps {
  placeId: string
  data?: locations.Location
}

type Popups = {
  type: 'warehouse_attr' | 'automation'
} | {
  type: 'gallery'
  props: {
    index: number
  }
} | {
  type: 'details'
  props: {
    rentableType?: warehouse.RentableType
    details: any[]
    count?: number
  }
} | {
  type: 'availability'
  props: {
    name: string
    placeId: string
    groupHash: string
    variantHash: string
    companyName: string
  }
}

const PlaceElement: React.FC<PlaceElementProps> = ({ placeId, data }) => {
  const { popup, openPopup } = usePopupState<Popups>()
  const { attributes } = useSelector(selectFilters)
  const placeData = useSelector(selectPlaceData)
  const types = useSelector(selectPlaceTypes)
  const config = useSelector(selectConfig)

  const sizes = placeData?.sizes || data?.sizes
  const warehouses = placeData?.warehouses
  const _ = placeData?.id ? placeData : (data || {})
  const categoryId = attributes?.categoryId || ''
  const warehouseTypeId = attributes?.warehouseTypeId || ''
  const [activeCategoryId, setActiveCategoryId] = useState(categoryId)
  const [activeWarehouseTypeId, setActiveWarehouseTypeId] = useState(warehouseTypeId)
  const isParkingSelected = activeCategoryId && Array.isArray(types)
    ? types.find(type => type?.defaultCategoryId?.value === activeCategoryId)?.rentableType === 'parking'
    : false
  const categoryPositions = activeCategoryId
    ? generateCategoryPositionTables(warehouses, activeCategoryId, !isParkingSelected)
    : undefined
  const showParkingSection = isParkingSelected && categoryPositions && categoryPositions.length > 0
  const tablesOfUniqueCategories = generateTablesOfUniqueCategories(types)
  const validSizes = activeCategoryId && Array.isArray(types)
    ? types?.filter((item) => item.defaultCategoryId?.value === activeCategoryId)
    : types
  const category = activeCategoryId && Array.isArray(_.categories)
    ? (_.categories as locations.LocationCategory[])?.find(category => category.categoryId === activeCategoryId)
    : undefined

  useFreshPlaceData()
  const dispatch = useDispatch()
  const { t } = useTranslation('map')
  const { push } = useHistory()

  useEffect(() => {
    if (!activeCategoryId && types && types.length > 0) {
      setActiveCategoryId(types[0]?.defaultCategoryId?.value)
      setActiveWarehouseTypeId(types[0]?.id)

    } else if (activeCategoryId && Array.isArray(types) && types.length > 0) {
      const validWarehouseType = types.find(type => type.defaultCategoryId?.value === activeCategoryId)
      if (validWarehouseType) {
        setActiveWarehouseTypeId(validWarehouseType?.id)

      } else {
        setActiveCategoryId(types[0]?.defaultCategoryId?.value)
        setActiveWarehouseTypeId(types[0]?.id)
      }
    }
  }, [activeCategoryId, types])

  const rent = (hash: string, data: basic.Form, date?: string) => {
    if (!config) return
    if (config?.blockedCart) {
      openPopup('blockedCart')

    } else {
      const identifier = v7()
      dispatch(
        addItemToBasket({
          hash,
          identifier,
          type: BASKET_TYPES.rent,
          object: data?.data?.object,
          hasOnlineAccess: data?.data?.hasOnlineAccess,
          minDate: date ? date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1') : undefined,
          image: Array.isArray(sizes)
            ? sizes.find(size => size.warehouseTypeId === data?.data?.warehouseTypeId)?.renders?.default
            : undefined,
          rentableType: data?.rentableType,
          name: data.warehouseTypeName,
          placeId,
        })
      )
      push(`/order/${identifier}`)
      dispatch(extendFormToMap(false))
    }
  }

  return (
    <>
      {popup?.type === 'warehouse_attr' && <WarehouseAttrPopup body={_.place_attrs} />}
      {popup?.type === 'automation' && <AutomationPopup body={_.automation} />}
      {popup?.type === 'gallery' && <GalleryPopup initialSlide={popup.props.index} data={_.photos} />}
      {popup?.type === 'details' && <DetailsPopup
        count={popup.props?.count}
        data={popup.props?.details}
        rentableType={popup.props?.rentableType}
      />}
      {popup?.type === 'availability' && <AvailabilityNotificationPopup
        placeId={placeId}
        companyName={placeData.companyName}
        groupHash={popup.props?.groupHash}
        variantHash={popup.props?.variantHash}
        name={popup.props?.name}
      />}

      <div className='objectDetails'>
        <div className='objectDetails__photo'>
          {_.photos && _.photos.length > 1
            ? <Carousel
              photos={_.photos}
            />
            : _.photos?.[0]?.public_path
              ? <img
                alt={_.photos[0].document_title}
                src={_.photos[0].public_path}
              />
              : <PlaceTemplatePhoto />}
          <div className={`objectDetails__badge ${_.constructionDate ? '--warning' : _.isAnnouncement ? '--secondary' : '--primary'}`}>
            {t(_.constructionDate ? 'theYardIsUnderConstruction' : _.isAnnouncement ? 'offer' : 'onlineRental')}
          </div>
        </div>

        {_.place_attrs && _.place_attrs.length > 0 && <div className='objectDetails__attributes__wrapper --border'>
          <div
            className='objectDetails__attributes'
            onClick={() => openPopup({ type: 'warehouse_attr' })}>
            {(_.place_attrs as any[]).map((item) => <div
              key={item.id}
              className='objectDetails__attribute'>
              <i className={`icon icon--${item.key}-bold`}></i>
              <span>{item.name}</span>
            </div>)}
          </div>
        </div>}

        {_.isAnnouncement
          ? <div className='objectDetails__tabs__wrapper'>
            <div className='objectDetails__tabs'>
              {tablesOfUniqueCategories.map((item) => <span
                key={item.value}
                className={`objectDetails__tab${item.value === activeCategoryId ? ' --selected' : ''}`}
                onClick={() => setActiveCategoryId(item.value)}>
                {item.name}
              </span>)}
            </div>
            {(validSizes && validSizes.length > 0) && <div className='placeDetails__sizes'>
              {(types as any[])?.map((item, idx) => {
                if (item.defaultCategoryId?.value !== activeCategoryId) return null
                return (
                  <div
                    key={idx}
                    className={`placeDetails__size${item.id === activeWarehouseTypeId ? ' --selected' : ''}`}
                    onClick={() => setActiveWarehouseTypeId(item.id)}>
                    {showParkingSection
                      ? item.templateName
                      : item.area ? `${Number(item.area).toFixed(0)} m²` : item.typeNameForClient}
                  </div>
                )
              })}
            </div>}
            <ArrowBtn
              enlarged
              text={t('showPhoneNumber')}
              action={() => {
                openPopup({ type: 'announcement', placeId: _.id })
              }}
            />
          </div>
          : <div className='objectDetails__tabs__wrapper'>
            <div className='objectDetails__tabs'>
              {tablesOfUniqueCategories.map((item) => <span
                key={item.value}
                className={`objectDetails__tab${item.value === activeCategoryId ? ' --selected' : ''}`}
                onClick={() => setActiveCategoryId(item.value)}>
                {item.name}
              </span>)}
            </div>

            {category?.automation && <div
              className='objectDetails__automation'
              onClick={() => openPopup({ type: 'automation' })}>
              <div className={`${category.automation?.key === 'full-automatic' ? 'green' : ''}`}>
                {category.automation?.key === 'full-automatic' && <i className='icon icon--shield-bold'></i>}
                <span>{category.automation?.title}</span>
              </div>
              <div>{category.automation?.description}</div>
            </div>}
            {(category?.important_attrs && category.important_attrs.length > 0) && category.important_attrs.map((item, idx) => <div
              key={idx}
              className='objectDetails__automation'>
              <div>
                <i className={`icon icon--${item.key === 'lock' ? 'lock-bold' : item.key}`}></i>
                <span>{item.title}</span>
              </div>
              <div>{item.name}</div>
            </div>)}

            {showParkingSection
              ? <>
                <div className='objectDetails__list__wrapper'>
                  <div className='objectDetails__subtitle'>{t('availableSizes')}</div>
                  <div className='objectDetails__list'>
                    {categoryPositions?.map(item => <MagElement
                      key={item.hash}
                      data={item}
                      showWarehouseTypeName
                      openPopup={(type: string) => {
                        if (type === 'details') {
                          openPopup({ type: 'details', props: { details: item?.details, count: item?.free_now_to_rent_count, rentableType: item?.rentableType } })
                        } else if (type === 'availability') {
                          openPopup({ type: 'availability', props: { name: `${item?.warehouseTypeName} - ${item?.name}`, groupHash: item.data.warehouseTypeId, variantHash: item.hash } })
                        }
                      }}
                      action={(date?: string) => {
                        rent(item.hash, item, date)
                      }}
                    />)}
                  </div>
                </div>
              </>
              : <>
                {category?.attributes && category.attributes.length > 0 && <div
                  className='objectDetails__attributes__wrapper'
                  onClick={() => openPopup({ type: 'warehouse_attr' })}>
                  <div className='objectDetails__subtitle'>{t('storageFeatures')}</div>
                  <div className='objectDetails__attributes'>
                    {category.attributes.map((item) => <div
                      key={item.id}
                      className='objectDetails__attribute'>
                      <i className={`icon icon--${item.key}-bold`}></i>
                      <span>{item.name}</span>
                    </div>)}
                  </div>
                </div>}
                <div className='objectDetails__variants__wrapper'>
                  <div className='objectDetails__subtitle'>{t('availableSizes')}</div>
                  <div className='objectDetails__variants'>
                    {(_.sizeGroups && _.sizeGroups.length > 0)
                      ? (_.sizeGroups as locations.LocationSizeGroup[])?.map(group => {
                        return <div
                          key={group.warehouseSizeGroupId}
                          className='objectDetails__variant --groups'>
                          <div className='objectDetails__variant__size'>
                            <i className='icon icon--cube' />
                            <div className='objectDetails__variant__size__rows --secFont'>
                              <div>{group.name}</div>
                              <div>{group.areaMinShortName} - {group.areaMaxShortName}</div>
                            </div>
                          </div>
                          <div className='objectDetails__variant__price'>
                            <span className='--secFont'>{group.monthlyGrossPrice ? displayPrice(group.monthlyGrossPrice) : '-'}</span>
                            <span> / {t('monthly')}</span>
                          </div>
                        </div>
                      })
                      : categoryPositions?.map(position => {
                        const { isAvailableForRentInFuture } = checkIsAvailableForRentInFuture(position?.isAvailableForRentNow, position?.for_rent)
                        return <div
                          key={position.hash}
                          className='objectDetails__variant'>
                          <div className='objectDetails__variant__size'>
                            {config?.showAvailableQuantity && <div className='amount'>
                              <div className='amount__bg'><span className={`${countBadge(position?.free_now_to_rent_count)}`}></span></div>
                              <div className='amount__desc'>{t('amount')}: {position?.free_now_to_rent_count}</div>
                            </div>}
                            {position?.data?.area && <>
                              <i className='icon icon--cube' />
                              <span className='--secFont'>{position?.data?.area} m<sup>2</sup></span>
                            </>}
                          </div>
                          <div className='objectDetails__variant__price'>
                            <span className='--secFont'>{position?.data?.monthlyGrossPrice ? displayPrice(position.data.monthlyGrossPrice) : '-'}</span>
                            <span> / {t('monthly')}</span>
                          </div>
                          <ArrowBtn
                            showArrow={false}
                            className='--gray'
                            text={t((position?.isAvailableForRentNow || isAvailableForRentInFuture)
                              ? 'see'
                              : 'notify'
                            )}
                            action={() => {
                              push(`/mapdetails/${_.id}?warehouseTypeId=${position.data?.warehouseTypeId}`)
                            }}
                          />
                        </div>
                      })}
                  </div>
                </div>
                <ArrowBtn
                  enlarged
                  showArrow
                  text={t('viewAllStorageUnits')}
                  action={() => {
                    push(`/mapdetails/${_.id}`)
                  }}
                />
              </>}

            {_.additionalDescription && <div className='objectDetails__additional__wrapper'>
              <div className='objectDetails__subtitle'>{t('description')}</div>
              <AdditionalText
                className='objectDetails'
                text={_.additionalDescription}
              />
            </div>}

            {_.companyName && <div className='objectDetails__additional__wrapper'>
              <div className='objectDetails__subtitle'>{t('aboutTheCompany')}</div>
              <AdditionalText
                className='objectDetails'
                text={_.companyName}
              />
            </div>}
          </div>}
      </div>
    </>
  )
}

export default PlaceElement